import React from "react"
import _ from "lodash"

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

import History from '@material-ui/icons/History';

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

export default class HistoryButton extends React.Component {

    state = {
        anchorEl: null,
        key: 0
    }   

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleClose = () => {
        this.setState({ anchorEl: null });
    }

    doReverse = () => {
        this.props.doReverse(this.state.key)
        this.state.key += 1
    }

    render() {

        const { anchorEl } = this.state;

        var {
            data
        } = this.props

        if(data.length < 2 || data.length === this.state.key) {
            return <span />
        }

        return (
            <div>
                <Button
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={() => this.doReverse()}
                >
                    <History className="marginRight" /> schrittweise Zurück
                </Button>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/Components/HistoryBackButton.js